module.exports = __webpack_public_path__ + "static/media/icon-withdraw.6b67e16d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-withdraw.svg
// module id = 1254
// module chunks = 19